import { routes } from '../constants';
import { SHOW_SALON_GACHA_TICKETS } from '../constants/featureFlags';
import {
  Call,
  Conversation,
  DetailAdminPoster,
  DetailFemale,
  FollowingPage,
  Home,
  Login,
  Message,
  MessageManagement,
  MyPage,
  NotFound,
  Search,
  ListMale,
  Signup,
  Payment,
  GamePage,
  FemaleMet,
  OrderHistory,
  CreatePost,
  Status,
  ReviewGirl,
  HowToUse,
  FAQ,
  AppInfo,
  PreviewMale,
  EditMale,
  StarDetail,
  EditMalePage,
  BuyPoints,
  PointHistoryDetail,
  PointHistoryPage,
  PointUsageHistory,
  PointHistory,
  IntroducingFriend,
  PremiumPurchased,
  FinishPayment,
  Ranking,
  LineCallback,
  YarikanoChat,
} from 'pages';
import TermsOfService from 'pages/AppInfo/TermsOfService';
import SpecialCommercialLaw from 'pages/AppInfo/SpecialCommercialLaw';
import PrivacyPolicy from 'pages/AppInfo/PrivacyPolicy';
import About from 'pages/AppInfo/About';
import GachaTickets from 'pages/MyPage/GachaTickets';

const routers = [
  {
    path: routes.SEARCH,
    component: Search,
  },
  {
    path: routes.LIST_MALE,
    component: ListMale,
    isProtected: true,
  },
  {
    path: routes.RANKING,
    component: Ranking,
  },
  {
    path: routes.GAME_PAGE,
    component: GamePage,
  },
  {
    path: routes.DETAIL_ADMIN_POSTER,
    component: DetailAdminPoster,
  },
  {
    path: routes.DETAIL_FEMALE,
    component: DetailFemale,
  },
  {
    path: routes.HOME,
    component: Home,
  },
  {
    path: routes.CREATE_POST,
    component: CreatePost,
    isProtected: true,
  },
  {
    path: routes.STATUS,
    component: Status,
  },
  {
    path: routes.MY_PAGE,
    component: MyPage,
    isProtected: true,
  },
  ...(SHOW_SALON_GACHA_TICKETS
    ? [
        {
          path: routes.GACHA_TICKETS,
          component: GachaTickets,
          isProtected: true,
        },
      ]
    : []),
  {
    path: routes.EDIT_MALE,
    component: EditMalePage,
    isProtected: true,
    children: [
      {
        path: '',
        component: EditMale,
        index: true,
      },
      {
        path: 'preview',
        component: PreviewMale,
      },
    ],
  },
  {
    path: routes.STAR_DETAIL,
    component: StarDetail,
    isProtected: true,
  },
  {
    path: routes.HOW_TO_USE,
    component: HowToUse,
    isProtected: true,
  },
  {
    path: routes.FAQ,
    component: FAQ,
    isProtected: true,
  },
  {
    path: routes.APP_INFO,
    component: AppInfo,
    children: [
      {
        path: 'terms-of-service',
        component: TermsOfService,
        index: true,
      },
      {
        path: 'special-commercial-law',
        component: SpecialCommercialLaw,
      },
      {
        path: 'privacy-policy',
        component: PrivacyPolicy,
      },
      {
        path: routes.ABOUT,
        component: About,
      },
    ],
  },
  {
    path: routes.FOLLOWING,
    component: FollowingPage,
    isProtected: true,
  },
  {
    path: routes.FEMALE_MET,
    component: FemaleMet,
    isProtected: true,
  },
  {
    path: routes.ORDER_HISTORY,
    component: OrderHistory,
    isProtected: true,
  },
  {
    path: routes.BUY_POINTS,
    component: BuyPoints,
    isProtected: true,
  },
  {
    path: routes.POINT_HISTORY,
    component: PointHistoryPage,
    isProtected: true,
    children: [
      {
        path: '',
        component: PointHistory,
        index: true,
      },
      {
        path: ':pointId',
        component: PointHistoryDetail,
      },
    ],
  },
  {
    path: routes.POINT_USAGE_HISTORY,
    component: PointUsageHistory,
    isProtected: true,
  },
  {
    path: routes.PREMIUM_PURCHASED,
    component: PremiumPurchased,
    isProtected: true,
  },
  {
    path: routes.CALL,
    component: Call,
  },
  {
    path: routes.MESSAGE,
    component: Message,
  },
  {
    path: routes.MESSAGE_MANAGEMENT,
    component: MessageManagement,
  },
  {
    path: routes.YARIKANO_CHAT,
    component: YarikanoChat,
  },
  {
    path: routes.CONVERSATION,
    component: Conversation,
  },
  {
    path: routes.PAYMENT,
    component: Payment,
    isProtected: true,
  },
  {
    path: routes.FINISH_PAYMENT,
    component: FinishPayment,
    isProtected: true,
  },
  {
    path: routes.REVIEW_GIRL,
    component: ReviewGirl,
  },
  {
    path: routes.LOGIN,
    component: Login,
  },
  {
    path: routes.SIGNUP,
    component: Signup,
  },
  {
    path: routes.LINE_CALLBACK,
    component: LineCallback,
  },
  {
    path: routes.INTRODUCING_FRIEND,
    component: IntroducingFriend,
  },
  {
    path: '*',
    component: NotFound,
  },
];

export default routers;
